import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';

import { Separator } from '../ui/separator';

import logo from '../../assets/carbase-logo.png';

const Footer = () => {
    return (
      <footer className="bg-gray-800 text-white py-12 mt-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center space-x-2 mb-4 justify-center md:justify-start">
                <img
                  src={logo}
                  alt="Logo"
                  className="h-14 object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <p className="text-gray-400 text-center md:text-left">
                Your trusted partner in finding the perfect vehicle. Quality
                vehicles, competitive prices, exceptional service.
              </p>
            </div>

            <div>
              <h4 className="font-semibold mb-4 text-center md:text-left">Quick Links</h4>
              <ul className="space-y-2 text-gray-400 text-center md:text-left">
                <li>
                  <Link to="/" className="hover:text-white transition-colors">
                    Browse Vehicles
                  </Link>
                </li>
                {/* <li>
                  <Link to="/" className="hover:text-white transition-colors">
                    Sell Your Vehicle
                  </Link>
                </li> */}
                {/* <li>
                  <Link to="/" className="hover:text-white transition-colors">
                    Financing
                  </Link>
                </li> */}
                {/* <li>
                  <Link to="/" className="hover:text-white transition-colors">
                    Insurance
                  </Link>
                </li> */}
                <li>
                  <Link
                    to="/admin"
                    className="hover:text-white transition-colors"
                  >
                    Admin
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-semibold mb-4 text-center md:text-left">Support</h4>
              <ul className="space-y-2 text-gray-400 text-center md:text-left">
                {/* <li>
                  <Link to="/" className="hover:text-white transition-colors">
                    Help Center
                  </Link>
                </li> */}
                <li>
                  <Link to="/contact" className="hover:text-white transition-colors">
                    Contact Us
                  </Link>
                </li>
                {/* <li>
                  <Link to="/" className="hover:text-white transition-colors">
                    Terms of Service
                  </Link>
                </li>
                <li>
                  <Link to="/" className="hover:text-white transition-colors">
                    Privacy Policy
                  </Link>
                </li> */}
              </ul>
            </div>

            <div className="text-center md:text-left">
              <h4 className="font-semibold mb-4">Contact Info</h4>
              <div className="space-y-2 text-gray-400">
                <div className="flex justify-center md:justify-start items-center">
                  <Phone className="h-4 w-4 mr-2" />
                  <a href="tel:+60123504244">
                    <span>+(60) 12-350 4244</span>
                  </a>
                </div>
                <div className="flex justify-center md:justify-start items-center">
                  <Mail className="h-4 w-4 mr-2" />
                  <a href="mailto:info@carbaseauto.com">
                    <span>info@carbaseauto.com</span>
                  </a>
                </div>
                <div className="flex justify-center md:justify-start items-center">
                  <MapPin className="h-4 w-4 mr-2" />
                  <a
                    href="https://www.google.com/maps?q=JVM+CarMotors+Kg.+Jawa+Bukit+Naga"
                    target="_blank"
                  >
                    <span>JVM CarMotors Kg. Jawa</span>
                  </a>
                </div>
                <div className="flex justify-center md:justify-start items-center">
                  <MapPin className="h-4 w-4 mr-2" />
                  <a
                    href="https://www.google.com/maps?q=J.V.+Car+Motors+Enterprise"
                    target="_blank"
                  >
                    <span>J.V. Car Motors Enterprise</span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <Separator className="my-8 bg-gray-800" />

          <div className="text-center text-gray-400">
            <p>&copy; {new Date().getFullYear()} Carbase. All rights reserved.</p>
          </div>
        </div>
      </footer>
    );
}

export default Footer;
